import { useEffect, useState } from 'react'

import anon from '@/assets/images/anon.png'

interface AvatarImageProps {
  avatarUrl: string | null | undefined
  onClick?: () => void
  className?: string
}

const AvatarImage = (props: AvatarImageProps) => {
  const { avatarUrl, onClick, className } = props
  const [imgSrc, setImgSrc] = useState(avatarUrl || anon)

  useEffect(() => {
    setImgSrc(avatarUrl || anon)
  }, [avatarUrl])

  const handleError = () => setImgSrc(anon)

  return <img src={imgSrc} alt="Avatar" className={className} onClick={onClick} onError={handleError} />
}

export default AvatarImage
